import React, { useEffect, useState } from "react";
import Logo from "../../images/praxisbharwani_logo.svg";

import { useTranslation } from "react-i18next";
import { API_BASE } from "../../config/api";

const Footer = (props) => {
  const { t } = useTranslation();
  const [openingTimes, setOpeningTimes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch opening times from the backend
    fetch(`${API_BASE}/opening-times`)
      .then((res) => res.json())
      .then((data) => {
        setOpeningTimes(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching opening times:", error);
        setLoading(false);
      });
  }, []);

  const formatTime = (timeString) => {
    if (!timeString) return "";
    return timeString.substring(0, 5); // Get HH:MM from HH:MM:SS
  };


  // Convert JavaScript day number (0-6, Sunday=0) to database enum
  const getDayEnum = (dayNumber) => {
    const daysMap = [
      "SUNDAY",
      "MONDAY",
      "TUESDAY",
      "WEDNESDAY",
      "THURSDAY",
      "FRIDAY",
      "SATURDAY",
    ];
    return daysMap[dayNumber];
  };

  const getDayName = (dayOfWeekEnum) => {
    const days = {
      SUNDAY: t("footer_time_sunday"),
      MONDAY: t("footer_time_monday"),
      TUESDAY: t("footer_time_tuesday"),
      WEDNESDAY: t("footer_time_wednesday"),
      THURSDAY: t("footer_time_thursday"),
      FRIDAY: t("footer_time_friday"),
      SATURDAY: t("footer_time_saturday"),
    };
    return days[dayOfWeekEnum] || "";
  };


  return (
    <footer className={`wpo-site-footer ${props.footerClass}`}>
      <div className="f-shape-1">
        <svg width="887" height="757" viewBox="0 0 887 757" fill="none">
          <g opacity="0.6" filter="url(#filter0_f_235_142)">
            <circle cx="353" cy="223" r="234" />
          </g>
          <defs>
            <filter
              id="filter0_f_235_142"
              x="-181"
              y="-311"
              width="1068"
              height="1068"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="150"
                result="effect1_foregroundBlur_235_142"
              />
            </filter>
          </defs>
        </svg>
      </div>
      <div className="f-shape-2">
        <svg width="696" height="606" viewBox="0 0 696 606" fill="none">
          <g opacity="0.6" filter="url(#filter0_f_235_143)">
            <circle cx="534" cy="534" r="234" />
          </g>
          <defs>
            <filter
              id="filter0_f_235_143"
              x="0"
              y="0"
              width="1068"
              height="1068"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="150"
                result="effect1_foregroundBlur_235_143"
              />
            </filter>
          </defs>
        </svg>
      </div>
      <div className="wpo-upper-footer">
        <div className="container">
          <div className="row">
            <div className="col col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="widget about-widget">
                <div className="logo widget-title">
                  <img src={Logo} alt="blog" width={300} />
                </div>
                {/* <p>{t("footer_text")}</p> */}
              </div>
            </div>
            <div className="col col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="widget wpo-contact-widget">
                <div className="widget-title">
                  <h3 style={{ fontWeight: "bold" }}>
                    {t("footer_time_title")}
                  </h3>
                  {/*
                  <p
                    style={{
                      position: "relative",
                      fontWeight: "bold",
                      margin: 0,
                      color: isClinicOpen() ? "green" : "red",
                    }}
                  >
                    {isClinicOpen()
                      ? t("footer_time_open")
                      : t("footer_time_close")}
                  </p>
                  */}
                </div>
                <div className="contact-ft">
                  <table style={{ width: "100%", fontSize: "14px" }}>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="2">Loading...</td>
                        </tr>
                      ) : (
                        openingTimes.map((time) => {
                          const hasEveningSlot =
                            Boolean(time.eveningOpeningTime) &&
                            Boolean(time.eveningClosingTime);

                          return (
                            <tr
                              key={time.id}
                              style={{
                                fontWeight:
                                  getDayEnum(new Date().getDay()) ===
                                  time.dayOfWeek
                                    ? "bold"
                                    : "300",
                              }}
                            >
                              <td
                                style={{
                                  whiteSpace: "nowrap",
                                  paddingRight: "15px",
                                  verticalAlign: "top",
                                }}
                              >
                                {getDayName(time.dayOfWeek)}
                              </td>
                              {time.isClosed ? (
                                <td>{t("footer_time_closed")}</td>
                              ) : (
                                <td style={{ lineHeight: "1.6" }}>
                                  <div>
                                      <span>
                                        {formatTime(time.openingTime)} -{" "}
                                        {formatTime(time.closingTime)}
                                      </span>
                                      {hasEveningSlot && (
                                        <span style={{ marginLeft: "16px" }}>
                                          {formatTime(time.eveningOpeningTime)}{" "}
                                          -{" "}
                                          {formatTime(time.eveningClosingTime)}
                                        </span>
                                      )}
                                    </div>
                                </td>
                              )}
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="col col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="widget wpo-contact-widget">
                <div className="widget-title">
                  <h3 style={{ fontWeight: "bold" }}>
                    {t("footer_contact_title")}
                  </h3>
                </div>
                <div className="contact-ft">
                  <ul>
                    <li>
                      <i className="fi flaticon-placeholder"></i>Kalkumer Str.
                      151, 40468 Düsseldorf
                    </li>
                    <li>
                      <i className="fi flaticon-phone-call"></i>0211 4792626
                    </li>
                    <li>
                      <i className="fa fa-fax"></i>0211/4963909
                    </li>
                    <li>
                      <i className="fi flaticon-email"></i>
                      praxisbharwani@gmail.com
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="wpo-lower-footer">
        <div className="container">
          <div className="row">
            <div className="col col-xs-12">
              <p className="copyright">
                Copyright &copy;<span>{new Date().getFullYear()}</span>
                <span className="copyright-icon">|</span> All Rights Reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
